// employee/reducers.ts
const initialState = {
    getEmployeeData: [],
    getUserRightsData: [],
    getEmployeeCount: null,
    createEmployeeData: null,
    createUserRightsData: null,
    updateEmployeeData: null,
    getEmployeeMetaMessage: null,
    getEmployeeSuccess: false,
    getEmployeeFailure: false,

    getUserRightsSuccess: false,
    getUserRightsFailure: false,

    createUserRightsSuccess: false,
    createUserRightsFailure: false,

    createEmployeeSuccess: false,
    createEmployeeFailure: false,
    updateEmployeeSuccess: false,
    updateEmployeeFailure: false,
    deleteEmployeeSuccess: false,
    deleteEmployeeFailure: false,
};

export default function EmployeeReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_EMPLOYEE_SUCCESS': {
            return {
                ...state,
                getEmployeeSuccess: true,
                getEmployeeData: action.payload?.data?.data?.data,
                getEmployeeCount: action.payload?.data?.data?.meta?.total,
                getEmployeeFailure: false,
            };
        }
        case 'GET_EMPLOYEE_FAILURE': {
            return {
                ...state,
                getEmployeeFailure: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                getEmployeeSuccess: false,
            };
        }
        case 'RESET_GET_EMPLOYEE': {
            return {
                ...state,
                getEmployeeSuccess: false,
                getEmployeeFailure: false,
                getEmployeeData: [],
                getEmployeeMetaMessage: null,
            };
        }

        case 'GET_USER_RIGHTS_SUCCESS': {
            return {
                ...state,
                getUserRightsSuccess: true,
                getUserRightsData: action.payload?.data?.data?.data,
                getUserRightsFailure: false,
            };
        }
        case 'GET_USER_RIGHTS_FAILURE': {
            return {
                ...state,
                getUserRightsFailure: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                getUserRightsSuccess: false,
            };
        }
        case 'RESET_GET_USER_RIGHTS': {
            return {
                ...state,
                getUserRightsSuccess: false,
                getUserRightsFailure: false,
                getUserRightsData: [],
                getEmployeeMetaMessage: null,
            };
        }

        case 'CREATE_EMPLOYEE_SUCCESS': {
            return {
                ...state,
                createEmployeeSuccess: true,
                createEmployeeData: action.payload?.data?.data?.data,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                createEmployeeFailure: false,
            };
        }
        case 'CREATE_EMPLOYEE_FAILURE': {
            return {
                ...state,
                createEmployeeFailure: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                createEmployeeSuccess: false,
            };
        }
        case 'RESET_CREATE_EMPLOYEE': {
            return {
                ...state,
                createEmployeeSuccess: false,
                createEmployeeFailure: false,
                createEmployeeData: null,
                getEmployeeMetaMessage: null,
            };
        }

        case 'CREATE_USER_RIGHTS_SUCCESS': {
            return {
                ...state,
                createUserRightsSuccess: true,
                createUserRightsData: action.payload?.data?.data?.data,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                createUserRightsFailure: false,
            };
        }
        case 'CREATE_USER_RIGHTS_FAILURE': {
            return {
                ...state,
                createUserRightsFailure: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                createUserRightsSuccess: false,
            };
        }
        case 'RESET_CREATE_USER_RIGHTS': {
            return {
                ...state,
                createUserRightsSuccess: false,
                createUserRightsFailure: false,
                createUserRightsData: null,
                getEmployeeMetaMessage: null,
            };
        }

        case 'UPDATE_EMPLOYEE_SUCCESS': {
            return {
                ...state,
                updateEmployeeSuccess: true,
                updateEmployeeData: action.payload?.data?.data?.data,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                updateEmployeeFailure: false,
            };
        }

        case 'UPDATE_EMPLOYEE_FAILURE': {
            return {
                ...state,
                updateEmployeeFailure: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                updateEmployeeSuccess: false,
            };
        }
        case 'RESET_UPDATE_EMPLOYEE': {
            return {
                ...state,
                updateEmployeeSuccess: false,
                updateEmployeeFailure: false,
                updateEmployeeData: null,
                getEmployeeMetaMessage: null,
            };
        }

        case 'DELETE_EMPLOYEE_SUCCESS': {
            return {
                ...state,
                deleteEmployeeSuccess: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteEmployeeFailure: false,
            };
        }
        case 'DELETE_EMPLOYEE_FAILURE': {
            return {
                ...state,
                deleteEmployeeFailure: true,
                getEmployeeMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteEmployeeSuccess: false,
            };
        }
        case 'RESET_DELETE_EMPLOYEE': {
            return {
                ...state,
                deleteEmployeeSuccess: false,
                deleteEmployeeFailure: false,
                getEmployeeMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
